import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=635d14be&scoped=true"
import script from "./ImageModal.vue?vue&type=script&lang=ts"
export * from "./ImageModal.vue?vue&type=script&lang=ts"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=635d14be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d14be",
  null
  
)

export default component.exports